interface StockSource {
    available_quantity?: number;
    quantity?: number;
    expired_available_quantity?: number;
}

export interface ExpiredStockUsage {
    material: string;
    material_code: string;
    quantity: number;
    measurement_unit: string;
    deductions?: { due_date: string; quantity: number }[];
}

export const getMaterialRequestStock = (material: StockSource) => {
    const nonnegative = (quantity: number) => Number.isFinite(quantity) ? Math.max(quantity, 0) : 0;
    const available = nonnegative(material.available_quantity ?? material.quantity ?? 0);
    const expired = nonnegative(material.expired_available_quantity ?? 0);
    return { available, expired, total: available + expired };
};
